import { Action } from '@ngrx/store';

export enum FilterActionTypes {
  Filters_Request = '[Filters] Filters Request',
  Filters_Success = '[Filters] Filters Success',
  Filters_Failure = '[Filters] Filters Failure'
}

export class LoadFilters implements Action {
  readonly type = FilterActionTypes.Filters_Request;
}

export class LoadFiltersSuccess implements Action {
  readonly type = FilterActionTypes.Filters_Success;
  constructor(public payload: { filters: [] }) {}
}

export class LoadFiltersFailure implements Action {
  readonly type = FilterActionTypes.Filters_Failure;
  constructor(public payload: any) {}
}

export type All = LoadFilters | LoadFiltersSuccess | LoadFiltersFailure;
